import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { LanguageService } from "../../../shared/services/language-service";
import { Adaa4HeaderComponent } from "./adaa4-header/adaa4-header";

@Component({
  selector: "adaa-adaa4-layout",
  imports: [RouterOutlet, Adaa4HeaderComponent],
  template: `
    <div class="adaa4" [dir]="languageService.direction()">
      <div class="page-bg" aria-hidden="true"></div>
      <adaa-adaa4-header />
      <main class="main">
        <router-outlet />
      </main>
    </div>
  `,
  styleUrl: "./adaa4-layout.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Adaa4LayoutComponent {
  readonly languageService = inject(LanguageService);
}
